import React, { useState } from 'react';
import { Box, Typography, Paper, Collapse, IconButton, Badge, Avatar, Divider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import TaskCard from './TaskCard';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const WorkPlannerSidebar = ({ tasks, onTaskUnschedule }) => {
    const [expandedSections, setExpandedSections] = useState({
        overdue: true,
        dueSoon: true,
        thisWeek: true,
        upcoming: true
    });
    const [isOver, setIsOver] = useState(false);

    const toggleSection = (section) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setIsOver(true);
    };

    const handleDragLeave = (e) => {
        // setIsOver(false);
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setIsOver(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsOver(false);

        const taskId = parseInt(e.dataTransfer.getData('taskId'));
        if (taskId) {
            onTaskUnschedule(taskId);
        }
    };

    const categories = [
        {
            key: 'overdue',
            label: 'Overdue',
            color: '#EF4444',
            icon: '🔴',
            tasks: tasks.overdue
        },
        {
            key: 'dueSoon',
            label: 'Due Soon',
            color: '#000000',
            icon: '⚫',
            tasks: tasks.dueSoon
        },
        {
            key: 'thisWeek',
            label: 'This Week',
            color: '#000000',
            icon: '⚫',
            tasks: tasks.thisWeek
        },
        {
            key: 'upcoming',
            label: 'Upcoming',
            color: '#000000',
            icon: '⚫',
            tasks: tasks.upcoming
        }
    ];

    return (
        <Paper
            elevation={0}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            sx={{
                p: 2,
                height: '100%',
                backgroundColor: isOver ? '#C7E0FF' : '#DEECFF',
                borderRadius: 2,
                overflow: 'auto',
                transition: 'background-color 0.2s',
                border: isOver ? '2px dashed #2563EB' : 'none'
            }}
        >
            <Box sx={{ mb: 3 }}>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Typography fontSize="16px" fontWeight={700}>
                        Unscheduled Tasks
                    </Typography>
                </Box>
                {isOver && (
                    <Typography variant="caption" color="#2563EB" fontWeight={600}>
                        Drop here to unschedule
                    </Typography>
                )}
            </Box>

            {categories.map((category) => (
                <Box key={category.key} sx={{ mb: 2 }}>

                    <Divider sx={{ borderBottom: '1px solid #e2e5e8' }} />
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            py: 1,
                            '&:hover': { backgroundColor: '#E5E7EB', borderRadius: 1, px: 1 }
                        }}
                        onClick={() => toggleSection(category.key)}
                    >

                        <Box display="flex" alignItems="center" gap={1}>

                            <span>{category.icon}</span>
                            
                            <Typography
                                variant="body2"
                                fontWeight={600}
                                sx={{
                                    color: category.key === 'overdue' ? category.color : '#000000'
                                }}
                            >
                                {category.label} ({category.tasks.length})
                            </Typography>
                        </Box>
                        <IconButton size="small">
                            {expandedSections[category.key] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </Box>

                    <Collapse in={expandedSections[category.key]}>
                        <Box sx={{ pl: 2, mt: 1 }}>
                            {category.tasks.map((task) => (
                                <Box key={task.id} sx={{ mb: 1 }}>
                                    <TaskCard task={task} isInSidebar={true} />
                                </Box>
                            ))}
                        </Box>
                    </Collapse>
                </Box>
            ))}

        </Paper>
    );
};

export default WorkPlannerSidebar;